import React from 'react';

function SpecificCare(props){  
  const { t } = props;

  return (
    <>
      <p>{t("care.p1")}</p>
      <p>{t("care.p2")}</p>
      <p>{t("care.p3")}</p>
      <p>{t("care.p4")}</p>
      <br /><br />
      <p>{t("care.pro_tip")}</p>
      <p>{t("care.pro_tip_content")}</p>
    </>
  );
}

const Care = (props) => {   
  const { t, changeWord } = props;
  let cleanTitle = t("care.label");
  
    return (<div className="content-ac ca hide">
    <input
      className="ac-input top"
      id="ac-6afd"
      name="ac-6afd"
      data-id="2400"
      data-slug="CARE"
      type="checkbox"
      onChange={ () => changeWord('CARE') }
    />
    <label className="ac-label" htmlFor="ac-6afd">{ cleanTitle }</label>
    <article className="ac-text ac-6afd">
      <div className="single-post-interior" tabIndex="0">
      <SpecificCare
        t = {t}
      />
      </div>
    </article>
  </div>
);    
}

export default Care;